<mat-toolbar
    class="p-0"
    [ngStyle]="{ 'background-color': toolbarBackgroundColor }"
>
    <!-- <mat-progress-bar *ngIf="loading" class="loading-bar" color="primary" mode="indeterminate"></mat-progress-bar> -->
    <!-- <mat-progress-bar *ngIf="loading" class="loading-bar" color="primary" mode="indeterminate"></mat-progress-bar> -->

    <div
        *ngIf="!toolbarData"
        fxFlex
        fxFill
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-button
                class="toggle-button-navbar mat-icon-button"
                fuseNavbarVertical="toggleBar"
                fxHide.gt-md
                (click)="toggleSidebarOpen('navbar')"
            >
                <i-feather
                    name="Menu"
                    [ngStyle]="{ color: toolbarIconColor }"
                ></i-feather>
            </button>
            <button
                mat-button
                class="toggle-button-navbar mat-icon-button"
                fuseNavbarVertical="toggleBar"
                fxHide.gt-md
                (click)="gotoHome()"
            >
                <i-feather
                    name="Home"
                    [ngStyle]="{ color: toolbarIconColor }"
                ></i-feather>
            </button>
        </div>
        <div
            fxFlex="0 1 auto"
            class="pr-16"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <button mat-button class="language-button" [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="iso font-size-16 text-uppercase">{{ selectedLanguage }}</span>
                    <div class="h-24 w-20">
                        <mat-icon class="ml-4 font-size-18">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </button>
            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
				<button mat-menu-item *ngFor="let lang of languages" (click)="changeLang(lang.id)">
					<div fxLayout="row" fxLayoutAlign="start center">
						<span class="iso calibri-font-regular">{{ lang.title | translate }}</span>
					</div>
				</button>
			</mat-menu>
            <div
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="16px"
            >
                <i-feather 
                    name="Mail" 
                    [matBadge]="unreadMessageCount || null"
                    (click)="chatIconClicked()"
                ></i-feather>

                <i-feather
                    name="Bell"
                    [matBadge]="sharedService.getCounter() > 0 ? sharedService.getCounter() : null "
                    (click)="notificationIconClicked()"
                ></i-feather>
            </div>
        </div>
    </div>

    <div
        *ngIf="toolbarData"
        class="top-nav mx-24 w-100-p"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <div fxLayout="row" fxLayoutAlign="center center">
            <mat-icon
                aria-hidden="false"
                aria-label="arrow back icon"
                (click)="goBack()"
            >
                arrow_back
            </mat-icon>
            <span class="fs-18 bold ml-20">{{ toolbarData.title | translate | truncate: 25}}</span>
        </div>

        <span
            *ngIf="
                toolbarData.title === 'PROJECT_DETAILS' &&
                contactPersons !== null
            "
            class="avatars fs-14 float-right"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            (click)="openBottomSheet()"
            (keydown)="onKeyDown($event)"
        >
            <img
                *ngIf="
                    contactPersons.length > 0 &&
                    contactPersons[0].ProfileImageUrl
                "
                [alt]="contactPersons[0].DisplayName"
                style="border-radius: 50%; object-fit: cover; overflow: hidden"
                class="avatar-1 h-32 w-32"
                [src]="contactPersons[0].ProfileImageUrl"
            />

            <ngx-avatars
                *ngIf="
                    contactPersons.length > 0 &&
                    !contactPersons[0].ProfileImageUrl
                "
                class="avatar-1"
                [round]="true"
                size="32"
                textSizeRatio="2.5"
                name="{{ contactPersons[0].DisplayName }}"
                value="{{ contactPersons[0].DisplayName }}"
                bgColor="#B7EAB5"
                fgColor="#4A72FF"
                initialsSize="2"
            >
            </ngx-avatars>

            <img
                *ngIf="
                    contactPersons.length > 1 &&
                    contactPersons[1].ProfileImageUrl
                "
                [alt]="contactPersons[1].DisplayName"
                style="border-radius: 50%; object-fit: cover; overflow: hidden"
                class="avatar-2 h-32 w-32"
                [src]="contactPersons[1].ProfileImageUrl"
            />

            <ngx-avatars
                *ngIf="
                    contactPersons.length > 1 &&
                    !contactPersons[1].ProfileImageUrl
                "
                class="avatar-2"
                [round]="true"
                size="32"
                textSizeRatio="2.5"
                name="{{ contactPersons[1].DisplayName }}"
                value="{{ contactPersons[1].DisplayName }}"
                bgColor="#B5B6EA"
                fgColor="#4A72FF"
                initialsSize="2"
            >
            </ngx-avatars>

            <ngx-avatars
                *ngIf="contactPersons.length > 2"
                class="avatar-3"
                [round]="true"
                size="32"
                textSizeRatio="2.5"
                name="{{ '+ ' + (contactPersons.length - 2) }}"
                value="{{ '+ ' + (contactPersons.length - 2) }}"
                bgColor="#f1f4ff"
                fgColor="#4A72FF"
                initialsSize="2"
            >
            </ngx-avatars>
        </span>

        <span
            *ngIf="
                toolbarData.route === 'chats'
            "
            class="fs-14 float-right"
            (click)="openBottomSheet()"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <mat-icon
                aria-hidden="false"
                aria-label="more"
            >
                more_vert
            </mat-icon>
        </span>
    </div>
</mat-toolbar>
